import React, { memo, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Login from '../Login/Login';
import SignUp from '../SignUp/SignUp';
import { CONTAINER } from '../../constants/containers';
import RecoverPassword from '../Recovery/RecoverPassword';

const AuthContainer = ({ visible, register, requestAccess, initialView, ...rest }) => {
  const [container, setContainer] = useState(initialView || CONTAINER.login);

  useEffect(() => {
    if (visible)
      setContainer(initialView || CONTAINER.login);
  }, [initialView, visible]);

  const onSignup = useCallback(() => {
    setContainer(CONTAINER.signup);
  }, []);

  const onLogin = useCallback(() => {
    setContainer(CONTAINER.login);
  }, []);

  const onRecovery = useCallback(() => {
    setContainer(CONTAINER.recovery);
  }, []);

  switch (container) {

    case CONTAINER.signup: {
      if (register)
        return <SignUp onLogin={onLogin} {...rest}/>;
      return <Login onSignup={onSignup} onRecovery={onRecovery} register={register}
        requestAccess={requestAccess} {...rest}/>;
    }
    case CONTAINER.recovery: {
      return <RecoverPassword onLogin={onLogin} {...rest}/>;
    }
    default: {
      return <Login onSignup={onSignup} onRecovery={onRecovery} register={register}
        requestAccess={requestAccess} {...rest}/>;
    }
  }

};

export default memo(AuthContainer);

AuthContainer.propTypes = {
  initialView: PropTypes.string,
  visible: PropTypes.bool
};
